<template>
    <highcharts  class="chart w-full h-full" :options="options" :ref="chartId" id="chartId"></highcharts>
</template>

<script>
    import {reduceBigNumbers} from '../main.js'
    import {numberFormat} from '../main.js'
    let data = {}
    const moment = require('moment')

    export default {
        props: ['data', 'chartId'],
        data: function(){
            return {
                options: {
                    chart: {
                        type: 'area',
                        plotBackgroundColor: null,
                        plotBorderWidth: null,
                        plotShadow: false,
                        backgroundColor:'rgba(255,255,255,0)',
                        spacingBottom: 5,
                        marginTop: 20,
                    },
                    title: {
                        text: ''
                    },
                    subtitle: {
                        text: ''
                    },
                    credits:{
                        enabled: false
                    },
                    xAxis:{
                        gridLineColor: '#AFA9A9',
                        tickWidth: 0,
                        lineColor: 'rgba(255,255,255,0)',
                    },
                    exporting:{
                        enabled:false
                    },
                    yAxis: [{
                        tickWidth: 0,
                        lineColor: 'rgba(255,255,255,0)',
                        width: 0,
                        title: { text: 'Precio', style: { color: '#3DFFFF' } },
                        labels: { format: '{value} €' },
                    }, {
                        tickWidth: 0,
                        lineColor: 'rgba(255,255,255,0)',
                        title: { text: 'Uds x dia',style:{color:'#9860A4'}  },
                        labels: { format: '{value}'},
                        opposite: true,
                        gridLineColor: 'rgba(255, 255, 255, .1)'
                    }],
                    //                    tooltip: {
                    //                        // enabled:true,
                    //                        // formatter: function() {
                    //                        //     return this.series.name + ' <b>' + numberFormat(this.y) + '</b>';
                    //                        // },
                    //                        enabled:false
                    //                    },
                    plotOptions: {
                        area:{
                            fillOpacity:.2,
                            lineWidth:3,
                            marker:{
                                enabled:false
                            },
                            shadow: {
                                offsetX: 2,
                                offsetY: 4,
                                opacity: .2,
                                width: 4,
                            }
                        }
                    },
                    legend: {
                        enabled:false,
                        itemStyle: {
                            color: '#fff',
                            fontWeight: 'thin',
                        }
                    },
                    credits: {
                        enabled: false
                    },
                    series: [{
                        name: 'Precio',
                        yAxis: 0,
                        color: '#3DFFFF',
                        type: 'area',
                        step: 'left',
                        data: []
                    }, {
                        name: 'Unidades / día',
                        yAxis: 1,
                        color: '#9860A4',
                        type: 'area',
                        step: 'left',
                        data: []
                    }]
                }
            }
        },
        methods: {
            updateData(){                
                let chart = this.$refs[this.chartId].chart;
                chart.series[0].setData(this.data.price)
                chart.series[1].setData(this.data.sales)
                //                for(var i = chart.series.length -1; i > -1; i--) {
                //                    chart.series[i].remove();
                //                }
                //
                //                let num = 0,
                //
                //                    colors = ['#4299e1', '#768194']
                //
                //                for(var serie in this.data){
                //
                //                    chart.addSeries({
                //                        type: 'area',
                //                        data: this.data[serie],
                //                        name: this.data[serie],
                //                        yAxis: num,
                //                        step: 'left',
                //                        color: colors[num]
                //                    })
                //
                //                    num = num +1
                //
                //                }

            }
        },
        watch: {
            data: {
                handler(a, b){
                    this.updateData();
                },
                deep: true
            },
        },
        mounted() {
            this.updateData();
        }
    };
</script>
<style lang="css">

    .highcharts-container{
        height: 100% !important;
        width: 100% !important;
    }

</style>
